// @ts-nocheck
import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { spawn } from 'redux-saga/effects';

import baseCurrencyReducer from './reducers/baseCurrency.reducer';
import reportingReducer from './reducers/reporting.reducer';
import reportingAdvancedFilterReducer from './reducers/reportingAdvancedFilter.reducers';
import reportingMapReducer from './reducers/reportingMap.reducer';
import resourcesReducer from './reducers/resources.reducer';
import sessionReducer from './reducers/session.reducer';
import userReducer from './reducers/user.reducer';
import { sagas as reportingSagas } from './sagas/reporting.sagas';
import { sagas as reportingAdvancedFilterSagas } from './sagas/reportingAdvancedFilter.sagas';

const rootReducer = combineReducers({
  baseCurrency: baseCurrencyReducer,
  reporting: reportingReducer,
  reportingAdvancedFilter: reportingAdvancedFilterReducer,
  reportingMap: reportingMapReducer,
  resources: resourcesReducer,
  session: sessionReducer,
  user: userReducer
});

function* rootSaga() {
  yield spawn(reportingSagas);
  yield spawn(reportingAdvancedFilterSagas);
}

const sagaMiddleware = createSagaMiddleware();
const reportingStore = createStore(rootReducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

export type ReportingRootState = ReturnType<typeof rootReducer>;
export type ReportingDispatch = typeof reportingStore.dispatch;
export default reportingStore;
